<template>
    <v-col cols="12" class="ReportDetail mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%;"
        >
    
            <v-col cols="12"  >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                    
                >
                 <v-row >
                        <v-col>
                        </v-col>
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#7F03BB"
                                    to="/system/reports/payment"
                            >
                                <v-icon>mdi-cart</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#FFB12A"
                                    @click="dialog.video = true"
                            >
                                <v-icon>mdi-play</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#0172C0"
                            >
                                <v-icon>mdi-flash</v-icon>
                        </v-btn>  
                    </v-row>
                    <v-row class="justify-space-around">
                    <v-col cols="12"  md="6" lg="6" xl="5">
                        <v-row class="align-center" >
                            <v-col>
                                <h2 class="font-weight-medium text-left title-reports my-6">Mis Reportes</h2>
                            </v-col>
                            <v-col>
                                <v-row class="align-center">
                                     <v-col cols="12" md="3" xl="2" class="pa-0">
                                        <p class="py-5 d-flex align-center mt-5">
                                            Reporte
                                        </p>
                                    </v-col>
                                    <v-col cols="12" md="9" xl="10" class="pa-0">
                                        <v-select
                                                style="height:20px"
                                                :items="['Analisis de Desempeño de plantas 1','Analisis de Desempeño de plantas 2']"
                                                placeholder="Selecciona un reporte."
                                                dense
                                        ></v-select>

                                    </v-col>    
                                </v-row>
                            </v-col>
                           
                        </v-row>
                        <v-card class="elevation-0 report-detail mx-auto rounded-lg"  >
                            <v-row
                               
                                class="pa-4 pt-0 justify-space-around"
                            >
                                <v-col cols="12" lg="6" xl="5">
                                    <h3>Análisis de Desempeño de<br> Plantas</h3>
                                    <p>
                                        Lorem Ipsum is simply dummy text of the<br>
                                        printing and typesetting industry. Lorem<br>
                                        Ipsum has been the industry's standard 
                                    </p>
                                    <v-card height="100px" class="card-numeros shadow-1 rounded-lg pa-3">
                                                            <v-row>
                                                                <v-col cols="10" class="mx-auto">
                                                                    <h2 class="color-purple">3/10</h2>
                                                                    <p class="font-weight-bold">Te quedan 7 descargas</p>
                                                                </v-col>
                                                            </v-row>
                                                    </v-card>
                                </v-col>
                                <v-col cols="12" lg="6" xl="5">
                                    <v-row>
                                        <v-col class="pa-1">
                                            <h5>
                                                Seleccionar
                                            </h5>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="3" class="pa-1">
                                            <p>
                                                Planta
                                            </p>
                                        </v-col>
                                        <v-col cols="9" class="pa-1">

                                            <v-select
                                                    style="height:20px"
                                                    :items="['Planta 1','Planta 2']"
                                                    placeholder="Selecciona una planta..."
                                                    dense
                                            ></v-select>

                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="3" class="pa-1">
                                            <p>
                                                Año
                                            </p>
                                        </v-col>
                                        <v-col cols="9" class="pa-1">

                                            <v-select
                                                    style="height:20px"
                                                    :items="['2018','2019','2020']"
                                                    placeholder="2019"
                                                    dense
                                            ></v-select>

                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="3" class="pa-1">
                                            <p>
                                                Tipo
                                            </p>
                                        </v-col>
                                        <v-col cols="9" class="pa-1">

                                            <v-select
                                                    style="height:20px"
                                                    :items="['Fotovoltáica (Listado)']"
                                                    placeholder="Fotovoltáica (Listado)"
                                                    dense
                                            ></v-select>

                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="3" class="pa-1">
                                            <p>
                                                Región
                                            </p>
                                        </v-col>
                                        <v-col cols="9" class="pa-1">

                                            <v-select
                                                    style="height:20px"
                                                    :items="['II Region de Antofagasta']"
                                                    placeholder="II Region de Antofagasta"
                                                    dense
                                            ></v-select>

                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="3" class="pa-1">
                                            <p>
                                                Comuna
                                            </p>
                                        </v-col>
                                        <v-col cols="9" class="pa-1">

                                            <v-select
                                                    style="height:20px"
                                                    :items="['Mejillones']"
                                                    placeholder="Mejillones"
                                                    dense
                                            ></v-select>

                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="pa-1 ">
                                            <v-btn
                                                class="btn-report-detail"
                                            >
                                                Descargar Informe 3/10
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            
                        
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" lg="6" xl="5">
                          <v-row class="align-center" >
                            <v-col>
                                <h2 class="font-weight-medium text-left title-reports my-6">Descargados</h2>
                            </v-col>
                          </v-row>
                        <v-card class="elevation-0 mt-5 mx-auto"  
                        >
                            <v-row
                            class="pa-4 pt-0"
                            >
                                <v-col cols="12">
                                    <v-row>
                                        <v-col class="pa-0 ml-6">
                                            <h5>
                                                Filtar por
                                            </h5>
                                        </v-col>
                                    </v-row>
                                    <v-row class="justify-space-around">
                                        <v-col cols="12" lg="6" xl="5" >
                                            <v-row>
                                                <v-col cols="3" class="pa-1">
                                                    <p>
                                                        Planta
                                                    </p>
                                                </v-col>
                                                <v-col cols="9" class="pa-1">

                                                    <v-select
                                                            style="height:20px"
                                                            :items="['Planta 1','Planta 2']"
                                                            placeholder="Selecciona una planta..."
                                                            dense
                                                    ></v-select>

                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="3" class="pa-1">
                                                    <p>
                                                        Año
                                                    </p>
                                                </v-col>
                                                <v-col cols="9" class="pa-1">

                                                    <v-select
                                                            style="height:20px"
                                                            :items="['2018','2019','2020']"
                                                            placeholder="2019"
                                                            dense
                                                    ></v-select>

                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="3" class="pa-1">
                                                    <p>
                                                        Tipo
                                                    </p>
                                                </v-col>
                                                <v-col cols="9" class="pa-1">

                                                    <v-select
                                                            style="height:20px"
                                                            :items="['Fotovoltáica (Listado)']"
                                                            placeholder="Fotovoltáica (Listado)"
                                                            dense
                                                    ></v-select>

                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" lg="6" xl="5" >
                                            <v-row>
                                                <v-col cols="3" class="pa-1">
                                                    <p>
                                                        Región
                                                    </p>
                                                </v-col>
                                                <v-col cols="9" class="pa-1">

                                                    <v-select
                                                            style="height:20px"
                                                            :items="['II Region de Antofagasta']"
                                                            placeholder="II Region de Antofagasta"
                                                            dense
                                                    ></v-select>

                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="3" class="pa-1">
                                                    <p>
                                                        Comuna
                                                    </p>
                                                </v-col>
                                                <v-col cols="9" class="pa-1">

                                                    <v-select
                                                            style="height:20px"
                                                            :items="['Mejillones']"
                                                            placeholder="Mejillones"
                                                            dense
                                                    ></v-select>

                                                </v-col>
                                                <v-col class=" d-flex justify-end">
                                                    <v-btn
                                                        class="btn-report-pruple"
                                                    >
                                                        Filtrar
                                                    </v-btn>
                                                </v-col>
                                                
                                            </v-row>
                                        </v-col>
                                    </v-row>
                            
                                    <template>
                                    <v-data-table dense :headers="headers" :items="desserts" item-key="name" class="elevation-0 table-report-2"></v-data-table>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    export default {
        name: 'ReportDetail',
        data: () => ({
            desserts: [
                {
                name: 'Nombre de la unidad',
                year: 2020,
                datePayment: '15-09-2020',
                actions: 'ver',
                },
                {
                name: 'Nombre de la unidad',
                year: 2020,
                datePayment: '15-09-2020',
                actions: 'ver',
                },
                {
                name: 'Nombre de la unidad',
                year: 2020,
                datePayment: '15-09-2020',
                actions: 'ver',
                },
                {
                name: 'Nombre de la unidad',
                year: 2020,
                datePayment: '15-09-2020',
                actions: 'ver',
                },
                {
                name: 'Nombre de la unidad',
                year: 2020,
                datePayment: '15-09-2020',
                actions: 'ver',
                },
            
            ],
            headers: [
                {
                text: 'Nombre del reporte',
                value: 'name',
                },
                { text: 'Año', value: 'year' },
                { text: 'Fecha de Compra', value: 'datePayment' },
                { text: 'Acciones', value: 'actions' },
            ],
            }),
        created: function () {
            this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>